import React from 'react'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Row, Text } from 'Components/UI'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import {
  MembershipFeatureRecordFieldsFragment,
  MembershipPackageRecordFieldsFragment,
} from 'GraphQL/DatoCMS/TypedDocuments'

import { useResponsiveLayout } from 'Hooks'

import Slider from './Slider'
import { Container, Content } from './styles'
import Table from './Table'

type Props = {
  packages?: MembershipPackageRecordFieldsFragment[]
  features?: MembershipFeatureRecordFieldsFragment[]
  secondary?: boolean
  onAction?: () => void
}

function TeeOffCorporateMembershipPackagesSection({
  packages,
  features,
  secondary,
  onAction,
}: Props) {
  const { isDesktop, isWideDesktop } = useResponsiveLayout()

  const tableView = isDesktop || isWideDesktop

  if (!packages?.length || !features?.length) return null

  return (
    <SectionContainer>
      <Container secondary={secondary}>
        <AppearingWrapper centered>
          <Content px={LANDING_CONTENT_PX} py={[44, 44, 80, 80, 100]}>
            <SubsectionTitle
              centered
              maxWidth={1000}
              subtitle="Explore our Corporate Membership options and discover the perks and benefits that Emajin Golf can offer you and your organisation."
              title="Tee off with our Corporate Membership packages"
            />

            {tableView ? (
              <Table
                features={features}
                packages={packages}
                secondary={secondary}
                onAction={onAction}
              />
            ) : (
              <Slider
                features={features}
                packages={packages}
                onAction={onAction}
              />
            )}

            <Row backgroundColor="graniteGray" p={5}>
              <Text color="text.inverse" header6>
                Additional Partnership Tiers available upon application.
              </Text>
            </Row>

            <Text
              body
              center
              maxWidth="70%"
              regular
              screen14={!tableView}
              screen18={tableView}
            >
              To maintain the nature of an inclusive network, Individual
              memberships are available at $1,000+gst.
              <br />
              Registered members for GA handicap: Business and Platinum up to 2,
              Partners up to 4 based on tier.
              <br />
              Major sponsorship is limited to no more than three per event. Hole
              sponsorships are valued at $2,000 (ex GST) per hole. In addition
              to membership, event charges range from $125 to $750 per person
              (ex GST) per event.
              <br />
              *Only avaliable on standard events
            </Text>
          </Content>
        </AppearingWrapper>
      </Container>
    </SectionContainer>
  )
}

export default TeeOffCorporateMembershipPackagesSection
